<template>
  <div>
    <Breadcrumb msg1="配镜业务" msg2="加工工单" />
    <el-card>
      <el-row :gutter="10" style="margin-bottom: 10px">
        <el-col :span="6"><el-input v-model="query.work_order_no" placeholder="工单号" clearable></el-input></el-col>
        <el-col :span="5">
          <el-select v-model="query.status" placeholder="状态" clearable>
            <el-option v-for="s in statusList" :key="s" :label="s" :value="s"></el-option>
          </el-select>
        </el-col>
        <el-col :span="6">
          <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
        </el-col>
      </el-row>
      <el-table :data="list" border>
        <el-table-column label="ID" prop="id" width="60"></el-table-column>
        <el-table-column label="工单号" prop="workOrderNo" width="140"></el-table-column>
        <el-table-column label="关联订单" prop="orderNo" width="140"></el-table-column>
        <el-table-column label="加工员" width="100"><template slot-scope="scope">{{ doctorNameOf(scope.row.processorId) }}</template></el-table-column>
        <el-table-column label="设备" prop="machine" width="120"></el-table-column>
        <el-table-column label="质检" prop="qualityCheck" width="90"></el-table-column>
        <el-table-column label="开始时间" prop="startTime" width="160"></el-table-column>
        <el-table-column label="完成时间" prop="finishTime" width="160"></el-table-column>
        <el-table-column label="状态" width="100">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status === '已交付' ? 'success' : ''">{{ scope.row.status }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="220">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="changeStatus(scope.row)">状态流转</el-button>
            <el-button size="mini" type="success" @click="edit(scope.row)">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination style="margin-top: 10px" :current-page="query.page" :page-sizes="[10, 20, 50]" :page-size="query.limit" layout="total, sizes, prev, pager, next, jumper" :total="total" @size-change="sizeChange" @current-change="pageChange"></el-pagination>
    </el-card>

    <el-dialog title="状态流转" :visible.sync="statusShow" width="400px">
      <el-select v-model="statusValue" style="width: 100%">
        <el-option v-for="s in statusList" :key="s" :label="s" :value="s"></el-option>
      </el-select>
      <span slot="footer">
        <el-button @click="statusShow = false">取消</el-button>
        <el-button type="primary" @click="submitStatus">确定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="编辑工单" :visible.sync="editShow" width="500px">
      <el-form :model="form" label-width="100px" v-if="editShow">
        <el-form-item label="加工员">
          <el-select v-model="form.processor_id" style="width: 100%">
            <el-option v-for="doc in doctors" :key="doc.id" :label="doc.realname" :value="doc.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="设备"><el-input v-model="form.machine"></el-input></el-form-item>
        <el-form-item label="质检">
          <el-select v-model="form.quality_check" style="width: 100%">
            <el-option label="合格" value="合格"></el-option>
            <el-option label="不合格" value="不合格"></el-option>
            <el-option label="待检" value="待检"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注"><el-input v-model="form.remark" type="textarea"></el-input></el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="editShow = false">取消</el-button>
        <el-button type="primary" @click="saveEdit">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Breadcrumb from '@/components/Breadcrumb'
export default {
  components: { Breadcrumb },
  data () {
    return {
      statusList: ['待加工', '加工中', '质检中', '完工', '待取件', '已交付'],
      query: { page: 1, limit: 10, work_order_no: '', status: '' },
      list: [],
      total: 0,
      statusShow: false,
      statusValue: '',
      statusRow: null,
      editShow: false,
      form: {},
      doctors: []
    }
  },
  created () {
    this.getData()
    this.$axios.http.get('/users/doctors').then(r => { if (r.data.status === 200) this.doctors = r.data.data || [] })
  },
  methods: {
    doctorNameOf (id) { const d = this.doctors.find(x => x.id === id); return d ? d.realname : '' },
    getData () {
      this.$axios.get('/workOrders', res => {
        this.list = res.data.records || []
        this.total = parseInt(res.data.total) || 0
      }, this.query)
    },
    search () { this.query.page = 1; this.getData() },
    sizeChange (s) { this.query.limit = s; this.getData() },
    pageChange (p) { this.query.page = p; this.getData() },
    changeStatus (row) {
      this.statusRow = row
      this.statusValue = row.status
      this.statusShow = true
    },
    submitStatus () {
      this.$axios.put(`/workOrders/${this.statusRow.id}/status`, () => { this.statusShow = false; this.getData() }, { status: this.statusValue })
    },
    edit (row) {
      this.form = Object.assign({}, row, {
        processor_id: row.processorId,
        machine: row.machine,
        quality_check: row.qualityCheck,
        remark: row.remark
      })
      this.editShow = true
    },
    saveEdit () {
      this.$axios.put(`/workOrders/${this.form.id}`, () => { this.editShow = false; this.getData() }, this.form)
    }
  }
}
</script>
